import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { chatSchema } from './chat.schema';

export const GetChatsListResponseSchema = ListResponseSchema(chatSchema);

export const GetChatResponseSchema = chatSchema;
export const ChatLookupResultSchema = Type.Object({
  chat_id: Type.String({ description: 'The ID of the Chat associated with the given user.' }),
  inbox_id: Type.Optional(Type.String({ description: 'The ID of the Inbox containing the chat, if applicable.' })),
  has_history: Type.Optional(
    Type.Boolean({
      description: 'Whether the provider could determine that the chat already contains message history.',
    }),
  ),
});

export const GetUserChatResponseSchema = Type.Object({
  object: Type.Literal('ChatLookup'),
  data: Type.Array(ChatLookupResultSchema, {
    description: 'Resolved chats associated with the given user. Empty if none could be resolved.',
  }),
});

export const StartChatResponseSchema = Type.Object({
  object: Type.Literal('ChatStarted'),
  chat_id: Type.String({ description: 'The ID of the started chat.' }),
  message_id: Type.Union([Type.Null(), Type.String(), Type.Array(Type.String())], {
    description:
      'The ID of the message sent. Some providers send attachments separately from the text content, which can result in multiple sent message IDs. If no message was sent, the value is `null`.',
  }),
});

export const PostComposingResponseSchema = Type.Object({
  object: Type.Literal('ComposingSet'),
});

export const UpdateChatResponseSchema = chatSchema;
export const DeleteChatResponseSchema = Type.Null();
export const AcceptChatRequestResponseSchema = chatSchema;

export type GetChatsListResponse = Static<typeof GetChatsListResponseSchema>;
export type GetChatResponse = Static<typeof GetChatResponseSchema>;
export type ChatLookupResult = Static<typeof ChatLookupResultSchema>;
export type GetUserChatResponse = Static<typeof GetUserChatResponseSchema>;
export type StartChatResponse = Static<typeof StartChatResponseSchema>;
export type UpdateChatResponse = Static<typeof UpdateChatResponseSchema>;
export type DeleteChatResponse = Static<typeof DeleteChatResponseSchema>;
export type AcceptChatRequestResponse = Static<typeof AcceptChatRequestResponseSchema>;
export type PostComposingResponse = Static<typeof PostComposingResponseSchema>;
